import React from "react"
import { Redirect } from "react-router-dom"

import { TwoFactorAuthenticationScreenContent } from "./ScreenContent"
import { useLoginService } from "../../providers/LoginService"

export const TwoFactorAuthenticationProtectedScreenContent = () => {
  const { getStoredCredentials } = useLoginService()
  return !!getStoredCredentials() ? <TwoFactorAuthenticationScreenContent/> : <Redirect to="/"/>
}
